import { logE } from "@blacknut/logging/dist";
import { Image } from "@blacknut/javascript-sdk/dist";
import clsx from "clsx";
import * as React from "react";
import { LOGGING_TAG } from "../../utils/Utils";
import styles from "./styles.module.scss";
import svgDownloader from "src/utils/SVGDownloader";
import { ReactComponent as Home } from "../../assets/dist/ic_home.svg";

export interface FadeInImageProps {
  image?: Pick<Image, "url">;
  className?: string;
  width?: number;
  height?: number;
  suffixOnPixelRatio1?: string;
}
const FadeInImage = ({
  className,
  width,
  height,
  image,
  suffixOnPixelRatio1,
}: FadeInImageProps) => {
  const style: { width?: number; height?: number; filter?: string } = {};
  const [error, setError] = React.useState(false);
  const [svgData, setSVGData] = React.useState<string>();
  if (width !== undefined) {
    style.width = width;
  }
  if (height !== undefined) {
    style.height = height;
  }

  let url = image && image.url;
  let isSVG = false;
  if (url && url.endsWith(".svg")) {
    isSVG = true;
  } else if (url && window.devicePixelRatio === 1 && suffixOnPixelRatio1) {
    url = `${url.slice(0, url.length - 4)}${suffixOnPixelRatio1}${url.slice(
      url.length - 4,
    )}`;
  }

  React.useEffect(() => {
    if (isSVG && image && image.url) {
      const subscription = svgDownloader.download(image.url).subscribe({
        next: (value) => {
          setSVGData(value);
        },
        error: () => {
          setError(true);
        },
      });

      return () => {
        subscription.unsubscribe();
      };
    }
    return () => {};
  }, [image, isSVG]);
  const onError = React.useCallback(() => {
    logE(LOGGING_TAG, "Caught error getting image %o", url);
    setError(true);
  }, [url]);

  return (
    <>
      {svgData && (
        <div
          className={clsx(styles.image, className)}
          dangerouslySetInnerHTML={{ __html: svgData }}
          style={style}
        />
      )}
      {image && !isSVG && (
        <img
          onError={onError}
          className={clsx(styles.image, error && styles.error, className)}
          style={style}
          src={url}
        />
      )}
      {!image && (
        <div className={clsx(styles.placeholder, className)} style={style}>
          <Home />
        </div>
      )}
    </>
  );
};
export default React.memo(FadeInImage);
